var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "9625195B-A369-4DB0-913A-74CB56E3E3D7")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-all-2020",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CustomerPage_Account_open_V1",
    transform: "translate(-323.000000, -430.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(325.000000, 431.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "18.653 7.5097 8.066 18.0997 1.24344979e-13 19.9997 1.9 11.9327 12.487 1.3537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.488,1.3505 L18.65,7.5135 L18.724,7.4405 C20.425,5.7385 20.425,2.9785 18.724,1.2765 C17.022,-0.4255 14.263,-0.4255 12.562,1.2765 L12.488,1.3505 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.488,11.3505 L8.65,17.5135 L8.724,17.4405 C8.65,17.5145435 2.488,11.3505435 2.562,11.2765 L2.488,11.3505 Z",
    id: "Stroke-3-Copy"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pen.a4c0ecf8.svg";
export { ForwardRef as ReactComponent };